<script>
  import {onMount} from 'svelte';
  import {parseJSON, startOfMonth} from 'date-fns';
  import {url} from '@sveltech/routify';
  import {nombreCompleto} from '../../../Modelos/Trabajador';

  import store from '../../../Stores/Trabajadores/ver-trabajador-store';

  import Titulo from "../../../Components/UI/Titulo.svelte";
  import Trabajador from "../../../Components/Trabajadores/Ver/Trabajador.svelte";
  import Calendario from "../../../Components/Trabajadores/Ver/Calendario.svelte";
  import Marcajes from "../../../Components/Trabajadores/Ver/Marcajes.svelte";
  import Loading from "../../../Components/UI/Loading.svelte";
  import Migas from "../../../Components/UI/Migas/Migas.svelte";
  import Miga from "../../../Components/UI/Migas/Miga.svelte";

  export let id = 0;

  let fecha = startOfMonth(sessionStorage.fecha ? (parseJSON(sessionStorage.fecha)) : new Date());
  onMount(() => store.cargaDatos(id, fecha, true));

  const cambiaMes = e => store.avanzaMes(e.detail);

  let calendario, trabajador, tipo, nombre;
  $: calendario = $store.mes;
  $: tipo = $store.calendario.tipo
  $: trabajador = $store.trabajador.trabajador;
  $: fecha = $store.fecha || fecha;
  $: nombre = nombreCompleto(trabajador);
</script>

<style>
    .contenedor {
        display: grid;
        grid-gap: var(--padding-global);
    }

    @media (min-width: 768px) {
        .contenedor {
            grid-template-columns: repeat(2, 1fr);
        }

        .trabajador {
            grid-column: 1;
            grid-row: 1;
        }

        .calendario {
            grid-column: 2;
            grid-row: 1;
        }

        .marcajes {
            grid-column: 1 / 3;
            grid-row: 2;
        }
    }

    @media (min-width: 1280px) {
        .contenedor {
            grid-template-columns: minmax(20em, 1fr) 3fr;
            grid-template-rows: max-content 1fr;
        }

        .trabajador {
            grid-column: 1;
            grid-row: 1;
        }

        .calendario {
            grid-column: 1;
            grid-row: 2;
        }

        .marcajes {
            grid-column: 2;
            grid-row: 1 / 3;
        }
    }
</style>

<svelte:head>
    <title>Detalle del trabajador</title>
</svelte:head>

<Migas>
    <Miga url={$url('/trabajadores')}>Trabajadores</Miga>
    {#if trabajador}
        <Miga actual>{nombre}</Miga>
    {/if}
</Migas>

<Titulo>Detalle del trabajador</Titulo>

{#if $store.cargando}
    <Loading/>
{:else}
    <div class="contenedor">
        <div class="trabajador">
            <Trabajador/>
        </div>

        <div class="calendario">
            <Calendario {tipo} {calendario} {trabajador} fecha={startOfMonth(fecha)}
                        on:cambio={cambiaMes}/>
        </div>

        <div class="marcajes">
            <Marcajes on:cambio={cambiaMes}/>
        </div>
    </div>
{/if}